<div class="metrics-container">
    <div class="metric-content">
        <label>Pacing</label>
        <span>{{overrideMetrics.pacing | kendoNumber: 'p'}}</span>
    </div>
    <div class="metric-content">
        <label>Sensitivity</label>
        <span>{{overrideMetrics.sensitivity}}</span>
    </div>
    <div class="metric-content">
        <label>Competition</label>
        <span>{{overrideMetrics.competition | kendoNumber: 'c0'}}</span>
    </div>
    <div class="metric-content" [hidden]="!overrideMetrics.otherClassBucketsDisplayFlag">
        <label>{{ overrideMetrics.otherClass }} - LB</label>
        <span>{{overrideMetrics.otherClassLeadBucket.bucketCode}} {{overrideMetrics.otherClassLeadBucket.fare | kendoNumber:'c2'}}</span>
    </div>
    <div class="metric-content second-row">
        <label>Booked</label>
        <span>{{overrideMetrics.booked}}</span>
    </div>
    <div class="metric-content second-row">
        <label>Proj Yield</label>
        <span>{{overrideMetrics.projectedYield | kendoNumber:'c2'}}</span>
    </div>
    <div class="metric-content second-row">
        <label>LY Yield</label>
        <span>{{overrideMetrics.lyYield | kendoNumber:'c2'}}</span>
    </div>
        <div class="metric-content second-row" [hidden]="!overrideMetrics.singleOvrdAvailSeatsFlag">
        <label>Avail. Seats</label>
        <span>{{overrideMetrics.availableSeats}}</span>
    </div>
</div>
